goog.provide('el8.data.orderTests');

goog.require('el8.model.base');
goog.require('el8.util.consts');

(function() {

    // Model of a LabOrderTest or OrderSet
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        if (this.getTests()) {
            this.setId('OS'+this.getId());
        };
    };
    _class.addProperty('category');
    _class.addStringProperty('name');
    _class.addProperty('code');
    _class.addProperty('score');
    _class.addProperty('tests');
    _class.addProperty('diagnoses');

    _class.prototype.isOrderSet = function() {
        return Boolean(this.getTests());
    };

    el8.util.consts.ORDER_TYPES.map(function(type) {
        el8.data.orderTests[type] = new el8_EntitySet({
            model: function(spec) { return new _class(spec); },
            items: [],
            key: 'name',
            urlFn: '/get/'+type+'-order-test/',
            urlDataFn: function(name) { return {'name': name}; },
            urlIdFn: function(id) { return ('/get/'+type+'-order-test/?id='+id); }
        });
    });

})();


